import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose } from 'class-transformer';
import { IsOptional, IsString } from 'class-validator';
import { StoreItemsExposeGroup } from '../enum';
import { ReadAbstractItemMetadataPosDto } from './ReadAbstractItemMetadataPosDto';
export class ReadItemBaseGroupMetadataPosDto extends ReadAbstractItemMetadataPosDto {
}
__decorate([
    ApiProperty({ type: () => String, example: 'caa8b54a-eb5e-4134-8ae2-a3946a428ec7' }),
    Expose({
        groups: [
            StoreItemsExposeGroup.READ,
            StoreItemsExposeGroup.CREATE,
            StoreItemsExposeGroup.UPDATE,
            StoreItemsExposeGroup.PATCH,
            StoreItemsExposeGroup.BATCH_PATCH,
            StoreItemsExposeGroup.BATCH_CREATE,
        ],
    }),
    IsOptional({ groups: [StoreItemsExposeGroup.PATCH, StoreItemsExposeGroup.BATCH_PATCH] }),
    IsString({ always: true }),
    __metadata("design:type", String)
], ReadItemBaseGroupMetadataPosDto.prototype, "pos_guid", void 0);
//# sourceMappingURL=ReadItemBaseGroupMetadataPosDto.js.map